import { KeyValuePairArray } from '../KeyValuePair';
import { SortItem } from '../ss-api/responses/member.dashboard.license.response';
import { ISortable } from '../../helpers/sort';

export enum NoteTypes {
    Member = 0,
    GISCredit = 1,
    CreditCard = 2,
    LicenseKey = 3,
    Credit = 4,
    Invoice = 5,
    Ticket = 6,
    GISUsage = 7,
    AdminLog = 8,
    MemberLog = 9,
    Hubspot = 10
}

export interface INote {
    ID: number;
    Created: Date;
    CreatedAdminName: string;
    CreatedAdminID: number;

    Modified: Date;
    Note: string;
    Sticky: boolean;
    AdminID: number;
    MemberID: number;
    AdminName: string;

    RelationInfo: string;
    RelationObject: any;

    IsMember: boolean;
    MemberFullName: string;
    DesignerFullName: string;

    NoteTypeList: KeyValuePairArray<NoteTypes, number>;
}

export class NoteArray extends Array<Note> implements ISortable  {

    public LastSort = new SortItem;

    constructor(...items: Note[]) {
        super(...items);
        Object.setPrototypeOf(this, NoteArray.prototype);
    }

    static FixDates(notes: NoteArray) {

        if (notes == null || notes.length == 0)
            return;

        notes.forEach((note) => {
            Note.FixDates(note);
        });
    }

}

export class NoteTemplateItem {
    Title: string;
    Body: string;
}


export class NoteChangeResult {
    New: Note;
    Original: Note;
    Result: boolean;
    ResultMessage: string;
}


export class Note implements INote {
    // init values to prevent null exceptions on add new note
    ID: number;
    Created: Date = new Date();
    CreatedAdminName = '';
    CreatedAdminID = 0;

    Modified: Date = new Date();
    Note: string = '';
    Sticky: boolean = false;
    RequestReview: boolean = false;
    AdminID: number = 0;
    AdminName: string = '';
    RelationInfo: string = '';
    MemberID: number = 0;
    NoteTypeList = new KeyValuePairArray<NoteTypes, number>();
    RelationObject: any;

    IsMember: boolean;
    MemberFullName: string;
    DesignerFullName: string;

    // Note Templates
    public static NoteTemplates: NoteTemplateItem[] = [
        { Title : 'No Template Selected', Body : '' },
        { Title : 'Account Maintenance', Body : 'New card added online. Paid Invoice. No pending invoice.' },
        { Title : 'Account Maintenance - Added Auth Contact', Body : 'New card added online under NAME. Added as authorized contact. Paid invoice / No pending invoice.' },
        { Title : 'Account Maintenance - Vip3D Promo', Body : 'Vip3D promo, updated price and package.' },
        { Title : 'Added New Subscription', Body : 'Added new subscription with NAME. Understands automatic renewal. LICENSEKEY (This does not auto Force Post)' },
        { Title : 'License Key Cancelled', Body : 'Cancelled License Key via Acct Mgmt. LICENSEKEY' },
        { Title : 'License Key Opened', Body : 'Opened key for' },
        { Title : 'License Key Opened - Unlinked Designer', Body : 'Opened key, unlinked DESIGNER and transferred to NEW-DESIGNER. LICENSEKEY' },
        { Title : 'License Key Reactivated', Body : 'Reactivated key with NAME, understands automatic renewal will happen every 30 days.' },
        { Title : 'Login As Member', Body : 'Logging in as member for REASON' },
        { Title : 'Membership Cancelled - Given 10 day grace period', Body : 'Cancelled for non-payment. Invoice xx/xx Due - Key Active Until xx/xx' },
        { Title : 'Merge Duplicate Profiles', Body : 'Merged duplicate profiles. Force POST to SSDB' },
        { Title : 'Unlinked Designer', Body : 'Unlinked Designer per NAME . LICENSEKEY' },
        { Title : 'Updated Billing Info', Body : 'Updated Billing Info with NAME' },
        { Title : 'Updated Contact Info', Body : 'Updated Contact Info with NAME' },
    ];

    public static FixDates(note: Note) {

        if (note == null)
            return;

        note.Created = new Date(note.Created);
        note.Modified = new Date(note.Modified);
    }

    public static GetNoteTypeString(note: Note) {
        return NoteTypes[note.NoteTypeList[0].Key];
    }

    public static GetNoteType(note: Note) {
        return note.NoteTypeList[0].Key;
    }

    public static GetNoteTypeValue(noteTypeList: KeyValuePairArray<NoteTypes, number>, noteType: NoteTypes): number {

        let noteTypeObj = noteTypeList.find(x => x.Key == noteType);

        if (noteTypeObj == undefined)
            return 0;
        else
            return noteTypeObj.Value;

    }


}
